
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from "@/hooks/use-toast";
import { addYear } from './year/yearOperations';
import { extractYearErrorMessage } from './year/errorHandlers';

export interface YearMutationResult {
  addYearMutation: ReturnType<typeof useMutation<void, Error, string>>;
}

export const useYearMutations = (): YearMutationResult => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const addYearMutation = useMutation({
    mutationFn: addYear,
    onSuccess: () => {
      toast({ title: "Success", description: "Year added successfully" });
      // Invalidate and refetch years
      queryClient.invalidateQueries({ queryKey: ['years'] });
    },
    onError: (error) => {
      const errorMessage = extractYearErrorMessage(error);
      toast({ 
        title: "Error", 
        description: errorMessage,
        variant: "destructive" 
      });
    }
  });

  return {
    addYearMutation
  };
};
